import { insights } from "@/mocks/features";
import { SectionHead } from "./bits";

export default function Insights() {
  return (
    <section id="insights" className="scroll-mt-24 border-t border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <SectionHead
          eyebrow="Insider Reads"
          title="行业潜规则 · 潜规则解读"
          desc="把招商报价、佣金拆分、数据口径与“实锤”标准这些没人明说的行业规则讲透。看得懂行话，才不会轻易被带节奏。"
        />

        <div className="divide-y divide-background-200 border-y border-background-200 bg-background-50">
          {insights.map((ins) => (
            <article key={ins.id} className="group grid gap-4 px-4 py-7 transition hover:bg-background-100/70 md:grid-cols-12 md:items-center md:px-6">
              <div className="md:col-span-2">
                <span className="font-en text-5xl font-black leading-none text-background-300 transition group-hover:text-primary-200 md:text-6xl">
                  {ins.num}
                </span>
              </div>
              <div className="md:col-span-7">
                <h3 className="font-heading text-lg font-bold text-foreground-950 transition group-hover:text-primary-700 md:text-xl">
                  {ins.title}
                </h3>
                <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{ins.excerpt}</p>
              </div>
              <div className="flex items-center justify-between md:col-span-3 md:flex-col md:items-end md:gap-2">
                <span className="inline-flex items-center gap-1 text-sm text-foreground-600">
                  <i className="ri-eye-line text-foreground-400" /> {ins.reads} 阅读
                </span>
                <span className="inline-flex items-center gap-1 text-xs text-primary-600">
                  约 4 分钟深度阅读
                  <i className="ri-arrow-right-line transition group-hover:translate-x-1" />
                </span>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-5 flex items-start gap-2 rounded-lg border border-accent-200/70 bg-accent-50 p-4 text-xs leading-relaxed text-accent-900">
          <i className="ri-lightbulb-flash-line mt-0.5 text-base" />
          编辑部提示：以上解读基于行业公开信息与从业者访谈整理，目的在于帮助读者识别信息质量与话术，并非对任何具体主体的指控。遇到“疑似实锤”，请务必以权威信源为准。
        </p>
      </div>
    </section>
  );
}